"use client";

import { I18nUtil } from "@utils";
import React from "react";
import Translations from "@translate/components/TokenDetails/TokenDetailsSkeleton/ContentSkeleton";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

export const ContentSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-10 w-[728px]">
      {/* Price Chart Section */}
      <div className="flex flex-col gap-3 w-full">
        <div className="flex justify-between items-center w-full">
          <div className="w-[120px] h-6 bg-background_white_overlay5 rounded animate-pulse" />
          <div className="w-[120px] h-6 bg-background_white_overlay5 rounded animate-pulse" />
        </div>

        <div className="flex flex-col gap-2 w-full">
          <div className="flex items-center bg-background_white_overlay5 rounded p-3 h-[300px] w-full gap-[10px]">
            <div className="flex flex-col justify-between h-[240px] w-6">
              {[...Array(6)].map((_, i) => (
                <div
                  key={i}
                  className="w-full h-3 bg-background_white_overlay5 rounded animate-pulse"
                />
              ))}
            </div>
            <div className="flex-1 flex flex-col gap-1 h-full">
              <div className="flex-1 flex flex-col justify-between h-[260px] border-l border-b border-border_white_transparent20">
                {[...Array(6)].map((_, i) => (
                  <div
                    key={i}
                    className={cn(
                      "w-full h-3 border-b border-dashed border-border_white_transparent20",
                      {
                        "border-none": i === 5,
                      },
                    )}
                  />
                ))}
              </div>
              <div className="flex gap-3 h-3">
                {[...Array(3)].map((_, i) => (
                  <div
                    key={i}
                    className="flex-1 h-3 bg-background_white_overlay5 rounded animate-pulse"
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <div className="w-[163px] h-4 bg-background_white_overlay5 rounded animate-pulse" />
            <div className="w-[128px] h-4 bg-background_white_overlay5 rounded animate-pulse" />
          </div>
          <div className="flex gap-3 w-full">
            {[...Array(4)].map((_, i) => (
              <div
                key={i}
                className="flex-1 h-[44px] bg-background_white_overlay5 rounded animate-pulse"
              />
            ))}
          </div>
        </div>
      </div>
      {/* News Section */}
      <div className="flex flex-col gap-6 w-full">
        <h2
          aria-label="Content Skeleton h2"
          data-openreplay-label="Content Skeleton h2 Semantic"
          id="sem-content-skeleton-h2"
          className="text-headline-s text-content_primary"
        >
          {I18n.t("Related News, or Latest News")}
        </h2>
        <div className="flex flex-col gap-8">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex gap-5 w-full">
              <div className="flex-1 flex flex-col justify-between gap-2">
                <div className="w-[102px] h-4 bg-background_white_overlay5 rounded animate-pulse" />
                <div className="w-full h-[22px] bg-background_white_overlay5 rounded animate-pulse" />
                <div className="w-full h-[22px] bg-background_white_overlay5 rounded animate-pulse" />
                <div className="w-[230px] h-[22px] bg-background_white_overlay5 rounded animate-pulse" />
                <div className="w-[76px] h-5 bg-background_white_overlay5 rounded animate-pulse" />
              </div>
              <div className="w-[260px] h-[146px] bg-background_white_overlay5 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
